import * as xlsx from 'xlsx';
import * as xlsxPopulate from 'xlsx-populate/browser/xlsx-populate';
import { getFirstMultiDigitNumber } from '../../../globalFunctions/globalFunctions';

const ExportChecklistInExcelLogic = () => {
  const downloadChecklist = (name, data, opScopes, qualitativeAnswers) => {
    handleExport(name, data, opScopes, qualitativeAnswers).then(url => {
      console.log("url: ", url)
      const downloadAnchorNode = document.createElement('a');
      downloadAnchorNode.setAttribute('href', url);
      downloadAnchorNode.setAttribute('download', `${name}.xlsx`);
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    });
  };

  const workbook2blob = (workbook) => {
    const wopts = {
      bookType: "xlsx",
      bookSST: false,
      type: "binary",
    };

    const wbout = xlsx.write(workbook, wopts);

    // The application/octet-stream MIME type is used for unknown binary files.
    // It preserves the file contents, but requires the receiver to determine file type,
    // for example, from the filename extension.
    const blob = new Blob([s2ab(wbout)], {
      type: "application/octet-stream",
    });

    return blob;
  };

  const s2ab = (s) => {
    // The ArrayBuffer() constructor is used to create ArrayBuffer objects.
    // create an ArrayBuffer with a size in bytes
    const buf = new ArrayBuffer(s.length);

    //create a 8 bit integer array
    const view = new Uint8Array(buf);

    //charCodeAt The charCodeAt() method returns an integer between 0 and 65535 representing the UTF-16 code
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i);
    }

    return buf;
  };


  const handleExport = (name, data, opScopes, qualitativeAnswers) => {
    const title = [{ A: name }];

    let tableHeaders = {
      A: 'Question',
    };

    for (let i = 0; i < opScopes.length; i++) {
      let char = String.fromCharCode(i + 66); // 66 = 'B'
      tableHeaders[char] = opScopes[i].name;
    }

    const lastChar = String.fromCharCode(66 + opScopes.length); // colonna dopo l'ultimo opScope
    tableHeaders[lastChar] = 'Note';

    const cklt = JSON.parse(JSON.stringify(data));
    const enabledOpScopesIndexes = [];
    const disabledOpScopesIndexes = [];
    const enabledQntOpScopesIndexes = [];

    let checklistToDownload = cklt.map((el, index) => {
      const enabledOSObject = {};
      const disabledOSObject = {};
      const enabledQntOSObject = {};

      if (!el.operationalScopes) {
        el.operationalScopes = [...opScopes];
      }

      const elObj = {
        Question: el.title ? el.title : "",
      };

      el.operationalScopes.forEach((os, osIndex) => {
        const value = el.type
          ? ''
          : os.enabled
            ? (os.answer !== null ? os.answer : 'Answer Required')
            : 'N/A';

        elObj[os.name] = value;

        const columnChar = String.fromCharCode(66 + osIndex);

        if (!el.type && os.enabled) {
          if (el.questionType === 'qualitative') {
            if (!enabledOSObject.columns) enabledOSObject.columns = [];
            enabledOSObject.columns.push(columnChar);
            enabledOSObject.rowNumber = index + 2;
          } else {
            if (!enabledQntOSObject.columns) enabledQntOSObject.columns = [];
            enabledQntOSObject.columns.push(columnChar);
            enabledQntOSObject.rowNumber = index + 2;
          }
        } else if (!el.type && !os.enabled) {
          if (!disabledOSObject.columns) disabledOSObject.columns = [];
          disabledOSObject.columns.push(columnChar);
          disabledOSObject.rowNumber = index + 2;
        }
      });

      elObj["Note"] = el.note ? el.note : "";

      if (enabledOSObject.columns) enabledOpScopesIndexes.push(enabledOSObject);
      if (disabledOSObject.columns) disabledOpScopesIndexes.push(disabledOSObject);
      if (enabledQntOSObject.columns) enabledQntOpScopesIndexes.push(enabledQntOSObject);

      return elObj;
    });

    const fatQualIndexes = [];
    const principioIndexes = [];
    const requisitoIndexes = [];
    const ambitoIndexes = [];
    const questionIndexes = [];

    let principioDisplayId = 1;
    data.forEach((el, index) => {
      if (el.type === "fatQual") {
        fatQualIndexes.push(index);
      } else if (el.type === "principio") {
        principioIndexes.push(index);
        principioDisplayId = getFirstMultiDigitNumber(el.title);
      } else if (el.type === "requisito") {
        requisitoIndexes.push(index);
      } else if (el.type === "ambito") {
        ambitoIndexes.push(index);
      }
      if (!el.type) {
        questionIndexes.push(index);
        checklistToDownload[index].Question = `${principioDisplayId}.${el.displayId} | ${checklistToDownload[index].Question}`;
      }
    });

    const columnsOrder = ["Question", ...opScopes.map(os => os.name), "Note"];

    const wb = xlsx.utils.book_new();
    const sheet = xlsx.utils.json_to_sheet(checklistToDownload, {
      header: columnsOrder
    });
    const sheet1 = xlsx.utils.json_to_sheet(qualitativeAnswers, {
      skipHeader: true
    });

    xlsx.utils.book_append_sheet(wb, sheet, 'Checklist Questions');
    xlsx.utils.book_append_sheet(wb, sheet1, 'Variables');

    const workbookBlob = workbook2blob(wb);

    const totalRecords = data.length;
    const headersLength = columnsOrder.length;
    const charOfLastColumn = String.fromCharCode(64 + headersLength);

    const dataInfo = {
      tbodyRange: `A2:${charOfLastColumn}${headersLength + 1}`,
      theadRange: `A1:${charOfLastColumn}1`,
      tOpScopesHeadRange: `B1:${charOfLastColumn}1`,
      tFatQualRowsRanges: fatQualIndexes.map(i => `A${i + 2}:${charOfLastColumn}${i + 2}`),
      tFatQualIndexes: fatQualIndexes,
      tPrincipiRowsRanges: principioIndexes.map(i => `A${i + 2}:${charOfLastColumn}${i + 2}`),
      tPrincipioIndexes: principioIndexes,
      tRequisitiRowsRanges: requisitoIndexes.map(i => `A${i + 2}:${charOfLastColumn}${i + 2}`),
      tRequisitiIndexes: requisitoIndexes,
      tAmbitiRowsRanges: ambitoIndexes.map(i => `A${i + 2}:${charOfLastColumn}${i + 2}`),
      tAmbitoIndexes: ambitoIndexes,
      tQuestionTitlesCells: questionIndexes.map(i => `A${i + 2}`),
      tTitlesRange: `A2:A${totalRecords + 2}`,
      qualitativeAnswersRange: `A1:A${qualitativeAnswers.length}`,
      tEnabledOpScopesIndexes: enabledOpScopesIndexes,
      tDisabledOpScopesIndexes: disabledOpScopesIndexes,
      tEnabledQntOpScopesIndexes: enabledQntOpScopesIndexes
    };

    return addStyle(workbookBlob, dataInfo, tableHeaders);
  }



  const addStyle = (workbookBlob, dataInfo, headers) => {
    return xlsxPopulate.fromDataAsync(workbookBlob).then((workbook) => {
      console.log("workbook .then: ", workbook);
      const sheet = workbook.sheet(0);
      console.log("dataInfo: ", dataInfo)

      sheet.usedRange().style({
        fontFamily: "Calibri",
        verticalAlignment: "center",
        horizontalAlignment: "center",
        wrapText: true,
        fontSize: 9
      });

      const qualAnsList = {
        type: 'list',
        allowBlank: false,
        showInputMessage: false,
        prompt: false,
        promptTitle: 'String',
        showErrorMessage: false,
        error: 'String',
        errorTitle: 'String',
        operator: 'String',
        formula1: `Variables!${dataInfo.qualitativeAnswersRange}`,//Required // ${qualAnsChar}1:${qualAnsChar}5
        formula2: 'String'
      }

      dataInfo.tEnabledOpScopesIndexes.forEach(osIndex => {
        for (let col of osIndex.columns) {
          workbook.sheet(0).cell(`${col}${osIndex.rowNumber}`)
            .dataValidation(qualAnsList)
            .style({
              bold: true,
              fontSize: 10
            });
        }
      });

      dataInfo.tDisabledOpScopesIndexes.forEach(osIndex => {
        for (let col of osIndex.columns) {
          workbook.sheet(0).cell(`${col}${osIndex.rowNumber}`)
            .style({
              fill: 'e7e7e7',
              fontColor: '949494'
            })
        }
      });

      dataInfo.tEnabledQntOpScopesIndexes.forEach(osIndex => {
        for (let col of osIndex.columns) {
          workbook.sheet(0).cell(`${col}${osIndex.rowNumber}`)
            .style({
              bold: true,
              fontColor: '003983',
              fontSize: 10
            })
        }
      });

      console.log("headers: ", headers)
      for (let key of Object.keys(headers)) {
        sheet.column(key).width(22);
      }
      sheet.column("A").width(84);

      // Headers
      sheet.range(dataInfo.theadRange).style({
        bold: true,
        horizontalAlignment: "center",
        verticalAlignment: "center",
        fill: '094853',
        fontColor: "ffffff",
        fontSize: 13
      });
      sheet.row(1).height(27);

      // Titles
      sheet.range(dataInfo.tTitlesRange).style({
        horizontalAlignment: "left",
        verticalAlignment: "top"
      })

      // FatQual
      dataInfo.tFatQualRowsRanges.forEach(range => {
        sheet.range(range).merged(true).style({
          bold: true,
          verticalAlignment: "center",
          fill: '162842',
          fontColor: "ffffff"
        })
      })
      dataInfo.tFatQualIndexes.forEach(index => {
        sheet.row(index + 1).height(20)
      })

      // Principi
      dataInfo.tPrincipiRowsRanges.forEach(range => {
        sheet.range(range).merged(true).style({
          bold: true,
          fill: '24426e',
          fontColor: "ffffff"
        })
      })

      // Requisiti
      dataInfo.tRequisitiRowsRanges.forEach(range => {
        sheet.range(range).merged(true).style({
          bold: true,
          fill: '3b65a5',
          fontColor: "ffffff"
        })
      })

      // Ambiti
      dataInfo.tAmbitiRowsRanges.forEach(range => {
        sheet.range(range).merged(true).style({
          bold: true,
          fill: '8aa8d6',
          fontColor: "ffffff"
        })
      })

      // colors:
      // fatQual: 162842
      // principio: 24426e;
      // requisito: 3b65a5;
      // ambito: 8aa8d6;
      // quantitative opScope: 003983
      // disabled opScope: d4d4d4 with LOWER opacity

      return workbook
        .outputAsync()
        .then((workbookBlob) => URL.createObjectURL(workbookBlob));
    })
  }

  return {
    downloadChecklist
  }
}

export default ExportChecklistInExcelLogic;